import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ap-panel',
    templateUrl: './panel.component.html',
    styleUrls: ['./panel.component.css'],
    standalone: false
})
export class PanelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
